exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-wrapper .container[data-v-20b8253c] {\n  padding: 8px;\n  height: 600px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  overflow: auto;\n}\n.modal-wrapper .container section[data-v-20b8253c] {\n    width: 100%;\n}\n.modal-wrapper .button-wrapper[data-v-20b8253c] {\n  margin-top: 16px;\n}\n.modal-wrapper .table-wrapper[data-v-20b8253c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%;\n  position: relative;\n  padding: 8px;\n}\n.modal-wrapper .main-section[data-v-20b8253c] {\n  height: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20b8253c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChatBot/organisms/ModalQuestionnaireData.vue
// module id = LlWw
// module chunks = 0